module.exports = __webpack_public_path__ + "static/media/awaitingorders.a037d212.jpg";